import { isNullOrUndefined } from '@ps20-frontend/utils';
import { IAppState } from '../localStore';
import { environment } from '../../environments/environment';

export const selectErrorpageIsOpen = (state: IAppState): boolean =>
  state.transientState.errorPageOpen;

export const selectErrorPageTextIds = (state: IAppState): string | string[] =>
  state.transientState.errorPageTextIds;

export const selectErrorPageZusatTexte = (state: IAppState): string[] =>
  state.transientState.errorPageZusatzTexte;

export const selectErrorPageParams = (state: IAppState): { [key: string]: string } =>
  state.transientState.errorPageParams;

export const selectSessionExpired = (state: IAppState): boolean =>
  state.transientState.sessionExpired;

export const selectConstructionPageOpen = (state: IAppState): boolean =>
  state.transientState.constructionPageOpen;

export const selectForwardedToUnderwriterPageOpen = (state: IAppState): boolean =>
  state.transientState.forwardedToUnderwriterPageOpen;

export const selectUserLoggedOut = (state: IAppState): boolean =>
  state.transientState.userLoggedOut;

export const selectVnAddressInvalidPageOpen = (state: IAppState): boolean =>
  state.transientState.vnAddressInvalid.open;

export const isApigeeActiveAndNotPermasession = (state: IAppState): boolean =>
  environment.apigeeActive && !state.transientState?.datenhaltung?.permasession;

export const isSdwSession = (state: IAppState): boolean =>
  !isNullOrUndefined(state.transientState?.datenhaltung?.sdw?.role) &&
  !isNullOrUndefined(state.transientState?.datenhaltung?.sdw?.partyId);

export const shouldUseSdwEndpoint = (state: IAppState): boolean =>
  isSdwSession(state) ||
  !isNullOrUndefined(state.transientState?.datenhaltung?.sdw?.accessToken);
